module.exports = __webpack_public_path__ + "static/media/15-hashtag.e33dd3ce.svg";